import { render, staticRenderFns } from "./CondicionalStatusBadge.vue?vue&type=template&id=234d2721"
import script from "./CondicionalStatusBadge.vue?vue&type=script&lang=js"
export * from "./CondicionalStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports